import { useEffect } from 'react';
import LegalPage from '@/components/LegalPage';
import { termsOfUseSV, termsOfUseEN } from '@/data/legal/terms-of-use';

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Användarvillkor - Beredskapshubben';
  }, []);

  return (
    <LegalPage 
      titleSV="Användarvillkor"
      titleEN="Terms of Use"
      contentSV={termsOfUseSV}
      contentEN={termsOfUseEN}
    />
  );
}
